<h2 mat-dialog-title class="mat-dialog-title-offset">{{modalHeader}}</h2>

<div class="modal-close-icon-container tw:flex tw:items-center">
  <button class="close-modal" mat-button [mat-dialog-close]="false" tabindex='-1'>
    <div class="close-modal modal-close-icon">
    </div>
  </button>
</div>

<mat-dialog-content class="mat-typography modal-master-container tw:mx-2">
  <div class="tw:w-full tw:p-4 tw:m-0 tw:mt-2 content-container">

    <mat-tab-group>
      <mat-tab label="Details">

        <form [formGroup]="frmStudentMaintenance" class="tw:pt-6">
          <div class="tw:flex tw:flex-wrap tw:px-0 tw:pb-6 tw:mx-0 tw:mb-2">

            <div class="tw:w-full tw:p-0 tw:m-0">

              <div class="flex-row tw:p-0 tw:m-0 tw:mb-4">
                <div class="tw:w-full tw:p-0 tw:m-0 tw:flex tw:justify-center tw:md:justify-start"
                  [ngClass]="{'tw:md:w-1/2': studentUpdatedOn}">
                  <label class="date-label">Created On: {{studentCreatedOn | date : 'dd MMM yyyy
                  HH:mm'}}</label>
                </div>
                @if (studentUpdatedOn) {
                  <div class="tw:w-full tw:p-0 tw:m-0 tw:flex tw:md:w-1/2 tw:justify-center tw:md:justify-end"
                    >
                    <label class="date-label">Last Updated On: {{studentUpdatedOn | date : 'dd MMM yyyy
                    HH:mm'}}</label>
                  </div>
                }
                <div class="tw:w-full tw:p-0 tw:m-0 tw:flex tw:justify-center tw:md:justify-start">
                  <h3 class="tw:mb-2">Learner ID: {{studentId}}
                  </h3>
                </div>
                @if (studentQuickInfo != '') {
                  <div class="tw:w-full tw:p-0 tw:m-0 tw:flex tw:justify-center tw:md:justify-start"
                    >
                    <label class="text-primary-colour quick-info-label">{{studentQuickInfo}}</label>
                  </div>
                }
              </div>

              <div class="flex-row">
                <div class="flex-column">
                  <label class="field__toggle"><input type="checkbox" formControlName="hiddenFromAllocation" /><span class="field__toggle-track"></span> Hidden From Allocation</label>
                </div>
              </div>

              <div class="flex-row">
                <div class="flex-column">
                  <label class="field__label">First Name</label>
                  <input class="field__control body-content" formControlName="firstName" type="text" />
                  @if (frmStudentMaintenance.controls.firstName.errors && frmStudentMaintenance.controls.firstName.errors.required && frmStudentMaintenance.controls.firstName.touched) {
                    <span class="field__error">Please complete this field before continuing</span>
                  }
                </div>
                <div class="flex-column">
                  <label class="field__label">Last Name</label>
                  <input class="field__control body-content" formControlName="lastName" type="text" />
                  @if (frmStudentMaintenance.controls.lastName.errors && frmStudentMaintenance.controls.lastName.errors.required && frmStudentMaintenance.controls.lastName.touched) {
                    <span class="field__error">Please complete this field before continuing</span>
                  }
                </div>
              </div>

              <div class="flex-row">
                <div class="flex-column">
                  <label class="field__label">Unique Pupil Number (UPN)</label>
                  <input class="field__control body-content" formControlName="upn" type="text" />
                  @if (frmStudentMaintenance.controls.upn.errors && frmStudentMaintenance.controls.upn.errors.required && frmStudentMaintenance.controls.upn.touched) {
                    <span class="field__error">Please complete this field before continuing</span>
                  }
                </div>
                <div class="flex-column">
                  <label>Date of Birth</label>
                  <input type="date" class="field__control" formControlName="dateOfBirth">
                  @if (frmStudentMaintenance.controls.dateOfBirth.hasError('invalidDateFormat')) {
                    <span class="field__error">Invalid date format</span>
                  }
                  @if (frmStudentMaintenance.controls.dateOfBirth.errors && frmStudentMaintenance.controls.dateOfBirth.errors.required) {
                    <span class="field__error">Please complete this field before continuing</span>
                  }
                  </div>
                </div>

                <div class="flex-row">
                  <div class="flex-column">
                    <label class="field__label">Year Group</label>
                    <input class="field__control body-content" formControlName="yearGroup" type="text" />
                    @if (frmStudentMaintenance.controls.yearGroup.errors && frmStudentMaintenance.controls.yearGroup.errors.required && frmStudentMaintenance.controls.yearGroup.touched) {
                      <span class="field__error">Please complete this field before continuing</span>
                    }
                  </div>
                  <div class="flex-column">
                    <label class="field__label">Main Subject</label>
                    <input class="field__control body-content" formControlName="mainSubject" type="text" />
                    @if (frmStudentMaintenance.controls.mainSubject.errors && frmStudentMaintenance.controls.mainSubject.errors.required && frmStudentMaintenance.controls.mainSubject.touched) {
                      <span class="field__error">Please complete this field before continuing</span>
                    }
                    </div>
                  </div>

                  <div class="flex-row">
                    @if (themeService.siteContent.enableStudentEmailing == 'true') {
                      <div class="flex-column"
                        >
                        <label class="field__label">Email</label>
                        <input class="field__control body-content" formControlName="emailAddress" type="email" />
                        </div>
                      }
                      <div class="flex-column field">
                        <label class="field__label">Client</label>
                        <app-searchable-select formControlName="client" [items]="clientList"
                          displayField="clientName" valueField="clientId"
                          placeholder="Select a client" searchPlaceholder="Search clients…"></app-searchable-select>
                        @if (frmStudentMaintenance.controls.client.errors && frmStudentMaintenance.controls.client.errors.required && frmStudentMaintenance.controls.client.touched) {
                          <span class="field__error">Please complete this field before continuing</span>
                        }
                        @if (showClientAccessError) {
                          <div class="tw:text-danger">No Valid Client Roles
                            Assigned.
                          </div>
                        }
                      </div>
                    </div>

                    <div class="flex-row">
                      <div class="flex-column">
                        <label class="field__toggle"><input type="checkbox" formControlName="pupilPremium" /><span class="field__toggle-track"></span> Eligible for pupil premium</label>
                      </div>
                      <div class="flex-column">
                        <label class="field__toggle"><input type="checkbox" formControlName="sendPupil" /><span class="field__toggle-track"></span> Learner has SEND</label>
                      </div>
                    </div>
                    <div class="flex-row">
                      <div class="flex-column">
                        <label class="field__toggle"><input type="checkbox" formControlName="childrenInNeed" /><span class="field__toggle-track"></span> Children In Need</label>
                      </div>
                      <div class="flex-column">
                        <label class="field__toggle"><input type="checkbox" formControlName="lookingAfterChildren" /><span class="field__toggle-track"></span> Looking After Children</label>
                      </div>
                    </div>

                  </div>

                  @if (!modalInitializing) {
                    <div class="tw:w-full tw:p-0 tw:m-0"
                      >
                      <div class="flex-row">
                        <div class="flex-column">
                          <label class="field__label">Gender</label>
                          <select class="field__control" formControlName="gender">
                            <option value="2">Male</option>
                            <option value="10">Female</option>
                            <option value="6">Prefer Not To Say</option>
                          </select>
                        </div>
                        <div class="flex-column">
                          <label class="field__label">Age</label>
                          <input class="field__control body-content" formControlName="age" type="text" />
                        </div>
                      </div>
                      <div class="tw:pt-4">
                        <h3>Additional Information</h3>
                      </div>
                      <div class="flex-row tw:pt-2">
                        <div class="flex-column">
                          <label class="field__label">{{themeService.siteContent.learnerPupilLabel}} Background</label>
                          <textarea class="field__control" stringFormatter cdkTextareaAutosize cdkAutosizeMinRows="3"
                            formControlName="learnerBackground" cdkAutosizeMaxRows="5"></textarea>
                        </div>
                      </div>
                      <div class="flex-row">
                        <div class="flex-column">
                          <label class="field__label">Behavior Background</label>
                          <textarea class="field__control" stringFormatter cdkTextareaAutosize cdkAutosizeMinRows="3"
                            formControlName="behaviorBackground" cdkAutosizeMaxRows="5"></textarea>
                        </div>
                      </div>
                      <div class="flex-row">
                        <div class="flex-column">
                          <label class="field__label">Health and Safety Information</label>
                          <textarea class="field__control" stringFormatter cdkTextareaAutosize cdkAutosizeMinRows="3"
                            formControlName="healthAndSafetyInfo" cdkAutosizeMaxRows="5"></textarea>
                        </div>
                      </div>
                      <div class="flex-row">
                        <div class="flex-column">
                          <label class="field__label">Additional Learner Notes</label>
                          <textarea class="field__control" stringFormatter cdkTextareaAutosize cdkAutosizeMinRows="3"
                            formControlName="additionalNotes" cdkAutosizeMaxRows="5"></textarea>
                        </div>
                      </div>
                    </div>
                  }

                  @if (!modalInitializing) {
                    <div class="tw:w-full tw:p-0 tw:m-0"
                      >
                      <div class="form-group">
                        <label for="withdrawSharingDatalider" class="slider-button-label">Withdraw from data
                        sharing</label>
                        <br />
                        <label class="field__toggle">
                          <input type="checkbox" #withdrawSharingDataSlider name="withdrawSharingDataSlider"
                            formControlName="withdrawSharingData" />
                          <span class="field__toggle-track"></span>
                          {{ withdrawSharingDataSlider.checked == true ? 'Enabled' : 'Disabled' }}
                        </label>
                      </div>
                    </div>
                  }

                  @if (uploadResponseMessages.length > 0 || uploadResponseMainMessage != '') {
                    <div class="tw:w-full tw:p-0 tw:m-0 tw:mt-6"
                      >
                      <label [ngClass]="{'tw:text-danger': !successfulUpload}">{{uploadResponseMainMessage}}</label>
                      <ul>
                        @for (message of uploadResponseMessages; track message) {
                          <li>{{message}}</li>
                        }
                      </ul>
                    </div>
                  }


                </div>
              </form>

            </mat-tab>
            <mat-tab label="Timelines">
              <select-timeline-subject [studentId]="studentId" [studentName]="studentDisplayName" [placementId]="0"
                [clientId]="frmStudentMaintenance.get('client').value" (closeModal)="close()">
              </select-timeline-subject>
            </mat-tab>
            <mat-tab label="Bookings">

              <div class="placement-list">
                <div class="placement-controls">
                  @if (hasLaunchVideoLibraryPermission) {
                    <div>
                      @if (showLaunchVideoLibrary) {
                        <div class="placement-controls__inner">
                          <button class="btn  btn-primary" (click)="launchVideoLibrary()">Launch Video
                          Library</button>
                        </div>
                      }
                      @if (!showLaunchVideoLibrary) {
                        <div class="placement-controls__inner">
                          <p class="dc-message" #message>There are no digital classrooms assigned to this learner.
                          </p>
                          <button disabled class="btn  btn-primary" (mouseover)="showMessage()"
                          (mouseout)="hideMessage()">Launch Video Library</button>
                        </div>
                      }
                    </div>
                  }
                </div>

                <div>
                  <app-data-table
                    [columns]="bookingColumns"
                    [data]="placementInformation"
                    [pageSize]="5"
                    emptyMessage="No bookings found">
                    <ng-template appColumnCell="actions" let-row>
                      <button mat-button class="btn btn-primary" (click)="showTutorReport(row)">Tutor
                      Report</button>
                    </ng-template>
                  </app-data-table>
                </div>
              </div>

            </mat-tab>
          </mat-tab-group>
        </div>
      </mat-dialog-content>

      <mat-dialog-actions class="div-flex-buttons">
        <div class="tw:flex tw:flex-wrap tw:p-0 tw:m-0 tw:w-full">
          <div class="tw:w-full tw:p-0 tw:m-0">
            <button type="button" class="btn btn-primary tw:mx-1 tw:float-left" mat-dialog-close>Close</button>
            <button type="submit" class="btn btn-primary tw:mx-1 tw:float-right" (click)="saveStudentMaintenance()"
            [disabled]="disableSave">Save</button>
            @if (showEditButton) {
              <button type="submit" class="btn btn-primary tw:mx-1 tw:float-right" (click)="enableEdit()"
              [disabled]="!hasUpdatePermissions">Edit</button>
            }
            <!-- <button type="button" class="btn btn-primary tw:mx-1 tw:float-right" (click)="resetMaintenance()" *ngIf="formValueChanged && !modalInitializing">Reset</button> -->
          </div>
        </div>
      </mat-dialog-actions>
